/* eslint-disable max-len */
import * as React from 'react';

export function DocumentFileIcon(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
      <path
        d="M3.33333 8.125V6.875H10V8.125H3.33333ZM3.33333 4.79167V3.54167H10V4.79167H3.33333ZM1.25 10.2083H7.91667C8.27778 10.2083 8.61806 10.2917 8.9375 10.4583C9.25694 10.625 9.52778 10.8472 9.75 11.125L12.0833 14.1667V1.25H1.25V10.2083ZM1.25 15.4167H11.4583L8.77083 11.8958C8.65972 11.7569 8.53125 11.6493 8.38542 11.5729C8.23958 11.4965 8.08333 11.4583 7.91667 11.4583H1.25V15.4167ZM12.0833 16.6667H1.25C0.916667 16.6667 0.625 16.5417 0.375 16.2917C0.125 16.0417 0 15.75 0 15.4167V1.25C0 0.916667 0.125 0.625 0.375 0.375C0.625 0.125 0.916667 0 1.25 0H12.0833C12.4167 0 12.7083 0.125 12.9583 0.375C13.2083 0.625 13.3333 0.916667 13.3333 1.25V15.4167C13.3333 15.75 13.2083 16.0417 12.9583 16.2917C12.7083 16.5417 12.4167 16.6667 12.0833 16.6667ZM1.25 15.4167V1.25V15.4167ZM1.25 11.4583V10.2083V11.4583Z"
        fill="white"
        fillOpacity="0.56"
      />
    </svg>
  );
}

export function DocumnetFilledFileIcon(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
      <path
        d="M3.33333 8.125H10V6.875H3.33333V8.125ZM3.33333 4.79167H10V3.54167H3.33333V4.79167ZM13.2917 15.75L9.75 11.125C9.52778 10.8472 9.25694 10.625 8.9375 10.4583C8.61806 10.2917 8.27778 10.2083 7.91667 10.2083H0V1.25C0 0.916667 0.125 0.625 0.375 0.375C0.625 0.125 0.916667 0 1.25 0H12.0833C12.4167 0 12.7083 0.125 12.9583 0.375C13.2083 0.625 13.3333 0.916667 13.3333 1.25V15.4167C13.3333 15.4722 13.3299 15.5278 13.3229 15.5833C13.316 15.6389 13.3056 15.6944 13.2917 15.75ZM1.25 16.6667C0.916667 16.6667 0.625 16.5417 0.375 16.2917C0.125 16.0417 0 15.75 0 15.4167V11.4583H7.91667C8.08333 11.4583 8.23958 11.4965 8.38542 11.5729C8.53125 11.6493 8.65972 11.7569 8.77083 11.8958L12.3958 16.625C12.3403 16.6389 12.2882 16.6493 12.2396 16.6562C12.191 16.6632 12.1389 16.6667 12.0833 16.6667H1.25Z"
        fill="white"
      />
    </svg>
  );
}
